import { Reveal, SectionHead } from "./Reveal";
import { REGISTER_CATEGORIES } from "@/data/content";
import { BookOpen, Info } from "lucide-react";

const Registers = () => (
    <section id="registers" className="py-24 sm:py-32 border-t border-white/10 bg-[#0D1730]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHead
                eyebrow="Records & Registers"
                title="Labour Law Registers & Records"
                sub="We assist organisations in identifying, preparing and maintaining applicable statutory registers and records."
            />
            <div className="mt-14 grid sm:grid-cols-2 gap-5" data-testid="registers-grid">
                {REGISTER_CATEGORIES.map((cat, i) => (
                    <Reveal key={cat.title} delay={(i % 2) * 0.08}>
                        <div className="h-full border border-white/10 bg-[#0A1128] p-8 hover:border-sky-400/40 transition-colors duration-300">
                            <div className="flex items-center gap-3">
                                <span className="w-10 h-10 rounded-lg bg-blue-600/20 border border-blue-500/30 flex items-center justify-center">
                                    <BookOpen size={18} className="text-sky-400" />
                                </span>
                                <h3 className="font-heading text-lg font-semibold text-white">{cat.title}</h3>
                            </div>
                            <ul className="mt-6 space-y-2.5">
                                {cat.items.map((item) => (
                                    <li key={item} className="flex items-center gap-3 text-sm text-slate-300 border-b border-white/5 pb-2.5 last:border-0">
                                        <span className="w-1 h-1 rounded-full bg-sky-400 shrink-0" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.1}>
                <div className="mt-8 flex gap-4 border border-white/10 bg-[#0A1128] p-6" data-testid="registers-note">
                    <Info size={20} className="text-sky-400 shrink-0 mt-0.5" />
                    <p className="text-sm text-slate-300 leading-relaxed">
                        The exact registers and records depend on the applicable Labour Code, State Rules, establishment
                        type, employee strength, nature of work and other applicable legislation.
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Registers;
